import { render, staticRenderFns } from "./ProfileUser.vue?vue&type=template&id=64786153&scoped=true"
import script from "./ProfileUser.vue?vue&type=script&lang=js"
export * from "./ProfileUser.vue?vue&type=script&lang=js"
import style0 from "./ProfileUser.vue?vue&type=style&index=0&id=64786153&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64786153",
  null
  
)

export default component.exports